"use client";

import type { IFindMySchoolMapLevelBoundaryItem } from "@/providers/store/api/find-my-school/find-my-school.interface";

import {
  CommunityServicesListItem,
  type CommunityServicesListItemProps,
} from "./community-services-list-item";

export interface CommunityServicesListProps {
  items: IFindMySchoolMapLevelBoundaryItem[];
  highlightedBoundaryId?: string | null;
  onItemClick?: CommunityServicesListItemProps["onClick"];
  isLoading?: boolean;
  hasSearchedAddress?: boolean;
  variant?: CommunityServicesListItemProps["variant"];
}

export function CommunityServicesList({
  items,
  highlightedBoundaryId,
  onItemClick,
  isLoading = false,
  hasSearchedAddress = false,
  variant = "desktop",
}: CommunityServicesListProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-3">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-28 animate-pulse rounded-lg border border-gray-200 bg-gray-100"
          />
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-sm text-gray-500">
          {hasSearchedAddress
            ? "No community areas were found for this location."
            : "No community areas are available for this district."}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => (
        <CommunityServicesListItem
          key={item.boundaryId}
          isHighlighted={item.boundaryId === highlightedBoundaryId}
          item={item}
          variant={variant}
          onClick={onItemClick}
        />
      ))}
    </div>
  );
}
